import { render, staticRenderFns } from "./ResultStatusComponent.vue?vue&type=template&id=188f7b2c&scoped=true"
import script from "./ResultStatusComponent.vue?vue&type=script&lang=js"
export * from "./ResultStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f7b2c",
  null
  
)

export default component.exports